module.exports = __webpack_public_path__ + "img/cbr2r00-1.bf06a21c.gif";